<script>
	import { DialogNew, Icon } from '@shopboxai/sb-portal-components';
	export let data = {};
</script>

<DialogNew on:submit on:close topLevel={true}>
	<div slot="toggle" title="Delete item"><Icon name="delete" /></div>
	<div slot="header">Delete element?</div>
	<button class="primary" slot="primary-action">Yes, delete</button>
	<p slot="content">Do you want to permanently delete this element?</p>
</DialogNew>
